(function (root) {
  'use strict';

  function selection(product, value, message = '') {
    if (!product || !Array.isArray(product.variants) || typeof product.explicit !== 'boolean') return null;
    const id = product.explicit ? value : product.variants.length === 1 ? product.variants[0].id : '';
    if (!/^\d+$/.test(String(id || ''))) return null;
    const matches = product.variants.filter((variant) => String(variant.id) === String(id));
    if (matches.length !== 1) return null;
    const variant = matches[0];
    if (variant.available !== true || !Number.isSafeInteger(variant.price) || variant.price < 0 ||
        variant.min !== 1 ||
        !Number.isInteger(variant.increment) || variant.increment < 1 ||
        (1 - variant.min) % variant.increment !== 0 ||
        (variant.max != null && (!Number.isInteger(variant.max) || variant.max < 1)) ||
        typeof variant.madeToOrder !== 'boolean') return null;
    const item = { id: variant.id, quantity: 1 };
    if (variant.madeToOrder) item.properties = { Fulfillment: 'Made to Order' };
    if (product.gift === true) {
      if (typeof message !== 'string' || message.length > 300) return null;
      if (message.trim()) item.properties = { ...item.properties, 'Gift message': message.trim() };
    }
    return { item, price: variant.price };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { selection };
  if (!root.customElements || root.customElements.get('alvaura-cart-related-item')) return;

  class CartRelatedItem extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-related-add]');
      this.picker = this.querySelector('[data-related-picker]');
      this.select = this.querySelector('[data-related-variant]');
      this.message = this.querySelector('[data-related-gift-message]');
      this.price = this.querySelector('[data-related-price]');
      this.error = this.querySelector('[data-related-error]');
      try { this.product = JSON.parse(this.querySelector('[data-related-product]').textContent); }
      catch (_) { return; }
      if (!this.button || !this.price || !this.error) return;
      this.initialPrice = this.price.textContent;
      if (this.picker) {
        this.button.setAttribute('aria-controls', this.picker.id);
        this.button.setAttribute('aria-expanded', 'false');
      }
      this.select?.addEventListener('change', () => this.update());
      this.message?.addEventListener('input', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
    }

    update() {
      this.selected = selection(this.product, this.select?.value, this.message?.value || '');
      const canChoose = this.product?.explicit && this.select && this.picker?.hidden &&
        this.product.variants?.some((variant) => selection(this.product, String(variant.id)));
      try {
        this.price.textContent = this.selected ? new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
        }).format(this.selected.price / 100) : this.initialPrice;
      } catch (_) { this.selected = null; }
      this.button.disabled = this.busy || this.uncertain || (!this.selected && !canChoose);
    }

    async add() {
      if (this.busy || this.uncertain) return;
      this.update();
      if (!this.selected || (this.product.gift === true && this.picker?.hidden)) {
        if (this.picker && (this.select || this.message)) {
          this.picker.hidden = false;
          this.button.setAttribute('aria-expanded', 'true');
          this.update();
          (this.select || this.message).focus();
        }
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (!drawer?.getSectionsToRender || !drawer?.renderContents) return;
      let endpoint;
      try { endpoint = new URL(this.dataset.addUrl, root.location.href); }
      catch (_) { return; }
      if (endpoint.origin !== new URL(root.location.href).origin || !/\/cart\/add(?:\.js)?$/.test(endpoint.pathname)) return;
      const payload = { items: [this.selected.item], sections: drawer.getSectionsToRender().map((section) => section.id), sections_url: root.location.pathname };
      const preview = new URL(root.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) payload.sections_url += `?preview_theme_id=${preview}`;
      drawer.setActiveElement?.(this.button);
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      this.update();
      try {
        const response = await fetch(endpoint.toString(), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          this.error.textContent = typeof data.description === 'string' ? data.description : this.dataset.errorLabel;
          this.error.hidden = false;
          return;
        }
        if (!Array.isArray(data.items) || !data.items.some((item) => String(item.variant_id || item.id) === String(payload.items[0].id))) throw new Error('Unconfirmed add');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'alvaura-cart-related', cartData: data });
        }
        await drawer.renderContents(data);
      } catch (_) {
        this.uncertain = true;
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = this.dataset.uncertainLabel;
        this.error.replaceChildren(link);
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
  }

  root.customElements.define('alvaura-cart-related-item', CartRelatedItem);
})(typeof window === 'undefined' ? globalThis : window);
